import {
  dimensiondata_1_tetelek_group_w200_row,
  gigawatt_ora_value_1_data_precision_no_year_summary,
  month_column,
  year_column_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const haviVillanyMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/HaviVillanyMerleg',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_w200_row,
      year_column_expanded,
      month_column,
      gigawatt_ora_value_1_data_precision_no_year_summary,
      order_1,
      order_2
    ],
  },
};
